// Import głównego pliku stylów
import '../css/style.scss';

// Import AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

class App {
    /**
     * Animations On Scroll (AOS)
     */
    initAos() {
        AOS.init({
            duration: 800, // Czas trwania animacji w ms
            easing: 'ease-out-cubic', // Typ easingu
            once: true, // Animacja tylko raz
            offset: 100, // Offset od góry w px
            delay: 0, // Opóźnienie w ms
            anchorPlacement: 'top-bottom', // Punkt zakotwiczenia
            disable: function() {
                // Wyłącz na urządzeniach mobilnych jeśli chcesz
                return window.innerWidth < 768;
            }
        });
        
        console.log('AOS zainicjalizowane');
    }
    
    /**
     * Init headroom.js
     */
    initHeadroom() {
        const headerElement = document.querySelector('.js-headroom');
        if (headerElement && typeof window.Headroom === 'function') {
            var headroom = new Headroom(headerElement);
            headroom.init();
        } else {
            if (!headerElement) {
                console.warn('Element .js-headroom nie został znaleziony');
            }
            if (typeof window.Headroom === 'undefined') {
                console.warn('Headroom library nie jest dostępna');
            }
        }
    }
    
    /**
     * Init viewer.js
     */
    initViewer() {
        const lightBoxes = document.querySelectorAll('.viewer-js');
        if (lightBoxes.length > 0 && typeof window.Viewer === 'function') {
            lightBoxes.forEach(lightBox => {
                const viewer = new Viewer(lightBox, {
                    title: false,
                });
            });
        } else {
            if (lightBoxes.length === 0) {
                console.log('Brak elementów .viewer-js na stronie');
            }
            if (typeof window.Viewer === 'undefined') {
                console.warn('Viewer library nie jest dostępna');
            }
        }
    }
    
    /**
     * Class toggler
     */
    activeClassToggler() {
        const togglers = document.querySelectorAll('.-js-toggler');
        if (togglers) {
            togglers.forEach(toggler => {
                toggler.addEventListener('click', () => {
                    toggler.classList.toggle('active');
                });
            });
        }
    }
    
    /**
     * Execute on page ready
     */
    pageReady() {
        document.body.classList.add('loaded');
        document.body.classList.remove("preload");
    }

    /**
     * Custom cursor – mała kropka z mix-blend-mode:difference.
     */
    initCustomCursor() {
        if (window.matchMedia('(pointer: coarse)').matches) {
            // Na urządzeniach dotykowych nie pokazujemy własnego kursora.
            return;
        }

        let dot = document.querySelector('.cursor-dot');
        if (!dot) {
            dot = document.createElement('div');
            dot.className = 'cursor-dot';
            document.body.appendChild(dot);
        }

        const updatePosition = (e) => {
            dot.style.opacity = '1';
            dot.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
        };

        window.addEventListener('mousemove', updatePosition);

        // Ukryj kropkę, gdy kursor wychodzi poza okno.
        window.addEventListener('mouseleave', () => {
            dot.style.opacity = '0';
        });
    }

    /**
     * Ustawia wysokość pionowej linii obok social w hero.
     * Wzór: suma wysokości linków <a> w .hero-container__social + 30px.
     */
    updateHeroSocialLine() {
        const heroContainer = document.querySelector('.js-hero-container');
        const social = document.querySelector('.hero-container__social');
        if (!heroContainer || !social) {
            return;
        }

        const recalc = () => {
            const links = Array.from(social.querySelectorAll('a'));
            if (!links.length) {
                social.style.removeProperty('--hero-social-line-height');
                return;
            }

            let linksHeight = 0;
            links.forEach((link) => {
                const rect = link.getBoundingClientRect();
                if (rect && rect.height) {
                    linksHeight += rect.height;
                    console.log(`linksheight: ${linksHeight}`);
                }
            });

            const heroRect = heroContainer.getBoundingClientRect();
            const heroHeight = heroRect && heroRect.height ? heroRect.height : 0;
            console.log(`heroHeight: ${heroHeight}`);
            if (!heroHeight) {
                return;
            }

            // Wzór: hero-container / 2 - (wysokość linków + 30px) - 30px.
            const value = heroHeight / 2 - ((linksHeight + 30) / 2) - 30;
            console.log(`value: ${value}`);
            const finalValue = Math.max(0, value);
            console.log(`finalValue: ${finalValue}`);
            social.style.setProperty('--hero-social-line-height', `${finalValue}px`);
        };

        recalc();
        window.addEventListener('load', recalc);
        window.addEventListener('resize', recalc);
        window.addEventListener('orientationchange', recalc);
    }
    
    reinit() {
        this.initAos();
    }
    
    init() {
        this.initAos();
        this.initHeadroom();
        this.initViewer();
        this.activeClassToggler();
        this.initCustomCursor();
        this.updateHeroSocialLine();
        this.pageReady();
    }
}

// Inicjalizuj od razu gdy DOM jest gotowy
document.addEventListener('DOMContentLoaded', function() {
    const app = new App();
    app.init();
});

// Automatyczny import wszystkich plików JS (oprócz _app.js)
function requireAll(r) {
    r.keys().forEach(r);
}

// Import wszystkich plików JS z aktualnego folderu (oprócz lib/ i _app.js)
requireAll(require.context('./', false, /^(?!.*\/_app\.js$).*\.js$/));
 